export default __webpack_public_path__ + "static/media/black-ks.074ed1e1.png";